export default __webpack_public_path__ + "86210b05cb06fde07a1c9af755fd5637.svg";